module.exports = __webpack_public_path__ + "img/empty.a2cd6113.png";